import { Button } from "@mui/material";
import type { ButtonProps } from "@mui/material";

export interface AppButtonProps extends Omit<ButtonProps, "color"> {
    tone?: "primary" | "secondary" | "ghost" | "navy" | "destructive";
}

export const AppButton = ({ tone = "primary", sx, ...rest }: AppButtonProps) => {
    switch (tone) {
        case "secondary":
            return (
                <Button
                    {...rest}
                    variant="contained"
                    sx={{
                        backgroundColor: "secondary.light",
                        color: "secondary.dark",
                        "&:hover": {
                            backgroundColor: (theme) => theme.palette.secondary.light,
                            filter: "brightness(0.96)",
                        },
                        ...sx,
                    }}
                />
            );
        case "ghost":
            return (
                <Button
                    {...rest}
                    variant="text"
                    sx={{
                        color: "text.primary",
                        backgroundColor: "transparent",
                        "&:hover": {
                            backgroundColor: "action.hover",
                        },
                        ...sx,
                    }}
                />
            );
        case "navy":
            return (
                <Button
                    {...rest}
                    variant="contained"
                    sx={{
                        backgroundColor: "text.primary",
                        color: "common.white",
                        "&:hover": {
                            backgroundColor: "text.primary",
                            filter: "brightness(0.92)",
                        },
                        ...sx,
                    }}
                />
            );
        case "destructive":
            return <Button {...rest} variant="contained" color="error" sx={sx} />;
        case "primary":
        default:
            return <Button {...rest} variant="contained" color="primary" sx={sx} />;
    }
};
